import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../../constants/routes";
import { Trash } from "lucide-react";
import { Cog } from "lucide-react";
import { MdContentCopy } from "react-icons/md";

export const TemplateGridItem = ({
  template,
  onDeleteClick,
  onCloneClick,
}: any) => {
  const navigate = useNavigate();

  return (
    <div className=" group relative w-[250px] h-[150px] rounded bg-borderColor ">
      <img
        onClick={() => {
          navigate(`${ROUTES.DESIGN}/${template._id}`);
        }}
        src={template.previewImage}
        alt={template.internalName}
        className="w-full h-full p-1 object-cover hover:cursor-pointer /hover:cursor-pointer hover:ring focus:ring rounded"
      />

      <Link
        to={`${ROUTES.TEMPLATE_SETTINGS_FORM}/${template._id}`}
        title="Template Settings"
      >
        <Cog className=" opacity-0 group-hover:opacity-100 w-6 h-6 absolute top-2 left-2 text-white hover:bg-primary rounded p-1" />
      </Link>

      <div title="Delete">
        <Trash
          className=" opacity-0 group-hover:opacity-100 w-6 hover:cursor-pointer h-6 absolute top-2 right-2 text-white hover:bg-red-800 rounded p-1"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onDeleteClick(template._id);
          }}
        />
      </div>

      <div title="Clone">
        <MdContentCopy
          className=" opacity-0 group-hover:opacity-100 w-6 hover:cursor-pointer h-6 absolute bottom-2 left-2 text-white hover:bg-primary rounded p-1"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onCloneClick(template._id);
          }}
        />
      </div>

      <div className="flex w-full mt-2 px-1 line-clamp-1">
        {template?.internalName}
      </div>
    </div>
  );
};
